import { render, staticRenderFns } from "./supply-shortage-note.vue?vue&type=template&id=33b6d678&scoped=true&"
import script from "./supply-shortage-note.vue?vue&type=script&lang=js&"
export * from "./supply-shortage-note.vue?vue&type=script&lang=js&"
import style0 from "./supply-shortage-note.vue?vue&type=style&index=0&id=33b6d678&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b6d678",
  null
  
)

export default component.exports